/**
 * @generated SignedSource<<820b9e8bf5975d34890f06e180ceaceb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationBasedAgendaHeaderFragment_facility$data = {
  readonly club: {
    readonly logoImage: {
      readonly publicId: string;
    } | null | undefined;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
  } | null | undefined;
  readonly displayNameOrFacilityName: string;
  readonly memberBookingWindowDays: number | null | undefined;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedFiltersModalFragment_facility" | "useGetDurationBasedAgendaFilterBarValues_facility">;
  readonly " $fragmentType": "DurationBasedAgendaHeaderFragment_facility";
};
export type DurationBasedAgendaHeaderFragment_facility$key = {
  readonly " $data"?: DurationBasedAgendaHeaderFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedAgendaHeaderFragment_facility">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationBasedAgendaHeaderFragment_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetDurationBasedAgendaFilterBarValues_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DurationBasedFiltersModalFragment_facility"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayNameOrFacilityName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberBookingWindowDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "logoImage",
          "plural": false,
          "selections": [
            {
              "alias": "publicId",
              "args": null,
              "kind": "ScalarField",
              "name": "renderingKey",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FacilityLogoFragment_club"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "2b5d3eee7d11ef0597ebb20135a61c95";

export default node;
